export enum QuickDepositOption {
  APPLEPAY = "APPLEPAY",
  GOOGLEPAY = "GOOGLEPAY",
  CREDITDEBIT = "CREDITDEBIT",
  OTHER = "OTHER",
}
